module.exports = __webpack_public_path__ + "img/card1@2x.a9a41647.png";